import React from 'react';
import { Box, Button } from '@curves/ui-base';

import PropTypes from 'prop-types';
import CommonTabs from '@Local/Components/Layout/CommonTabs';
const TabsWithActions = ({ tabs, activeTab, onTabChange, actions }) => {
    return (
        <Box className="page-tabs tabs-bottom-line mb-4">
            <CommonTabs tabs={tabs} onTabChange={onTabChange} activeTab={activeTab} />
            {actions && (
                <Box className="btn-group">
                    {actions.map(({ label, variant, onClick, as, to }) => (
                        <Button key={label} variant={variant} onClick={onClick} component={as} to={to} color="primary">
                            {label}
                        </Button>
                    ))}
                </Box>
            )}
        </Box>
    );
};
TabsWithActions.prototype = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            value: PropTypes.string.isRequired,
            icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node, PropTypes.oneOf([null, undefined])]),
            component: PropTypes.elementType,
            to: PropTypes.string,
        }),
    ).isRequired,
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
            onClick: PropTypes.func.isRequired,
        }),
    ),
};
export default TabsWithActions;
